module.exports = __webpack_public_path__ + "static/media/iconExitWhite.9fd7a6c2.svg";